export class SidebarRoute {

  public icon: string;

  public activeIcon: string;

  public title: string;

  public route: string;

  public dashboardView?: 'personal' | 'team';

  constructor(
    icon: string,
    activeIcon: string,
    title: string,
    route: string,
    dashboardView?: 'personal' | 'team',
  ) {
    this.icon = icon;
    this.activeIcon = activeIcon;
    this.title = title;
    this.route = route;
    this.dashboardView = dashboardView;
  }
}
